import React from "react";
import {
  DISCLAIMER_LAST_REVIEWED_DATE,
  DISCLAIMER_PARAGRAPHS,
  DISCLAIMER_VERSION,
} from "../constants/disclaimer";

function DisclaimerPage() {
  return (
    <div className="container cookies-page-container">
      <div className="cookies-page-header">
        <img src="/logo.png" alt="Student Loan Modeller Logo" className="page-logo" />
        <h1 className="main-title cookies-page-title">Disclaimer</h1>
        <p className="app-intro cookies-page-intro">
          Please read this disclaimer carefully before using the Student Loan Amount Modeller (SLAM).
        </p>
      </div>

      <section className="cookies-section">
        {DISCLAIMER_PARAGRAPHS.map((paragraph, idx) => (
          <p key={idx}>{paragraph}</p>
        ))}
        <p>
          This page was last reviewed on <strong>{DISCLAIMER_LAST_REVIEWED_DATE}</strong>. By clicking
          <strong> I understand</strong> or otherwise actively accepting this disclaimer, you confirm that you
          have read and understood its terms.
        </p>
        <p className="policy-effective-date">
          <strong>Disclaimer version:</strong> {DISCLAIMER_VERSION}
        </p>
      </section>

      <div className="cookies-actions">
        <a className="cookie-btn cookie-btn-primary" href="/">
          Back to calculator
        </a>
      </div>
    </div>
  );
}

export default DisclaimerPage;
